import moment from "moment";

const safeUpper = (v) => (v || "").toString().toUpperCase().trim();

export function formatLinearStatistics(data = []) {
  function formatData(d = []) {
    return d.reduce(
      (acum, i) => {
        const apptDate = i?.spreedsheet?.apptDateType;
        if (!apptDate) return acum;

        const date = apptDate.split("T")[0];

        const parsed = moment(date, "YYYY-MM-DD", true);
        if (!parsed.isValid()) return acum;

        const numberOfWeekInMonth = Math.ceil(parsed.date() / 7);

        const index = Math.min(Math.max(numberOfWeekInMonth - 1, 0), 4);
        acum[index]++;

        return acum;
      },
      [0, 0, 0, 0, 0],
    );
  }

  return {
    labels: ["WEEK-1", "WEEK-2", "WEEK-3", "WEEK-4", "WEEK-5"],
    series: [
      formatData(data.filter(({ type }) => safeUpper(type) === "ELG")),
      formatData(data.filter(({ type }) => safeUpper(type) === "FBD")),
    ],
  };
}

export function formatTable(data = [], filter = "") {
  const normalizedFilter = safeUpper(filter);

  return data
    .filter(
      ({ type }) =>
        normalizedFilter === "" || safeUpper(type) === normalizedFilter,
    )
    .reduce(
      (acum, i) => {
        const StatusVerification = safeUpper(i?.StatusVerification);
        const StatusPatient = safeUpper(i?.StatusPatient);
        const missingRequiredInputQty = i?.missingRequiredInputQty ?? 0;
        const audited = i?.audited ?? false;
        const carrierName = safeUpper(i?.spreedsheet?.CarrierName);

        if (
          StatusVerification === "DONE BY DR" &&
          /^ACTIVE/.test(StatusPatient)
        ) {
          acum.active++;
        }

        if (
          StatusVerification === "DONE BY DR" &&
          StatusPatient !== "ACTIVE" &&
          StatusPatient.length > 6
        ) {
          acum.pending++;
        }

        if (missingRequiredInputQty > 0) {
          acum.hasMissingCodes++;
        } else {
          acum.noMissingCode++;
        }

        if (
          carrierName !== "EMPTY" &&
          carrierName !== "NO INSURANCE COMPANY" &&
          ((StatusVerification !== "EMPTY" &&
            !StatusVerification.includes("DONE BY")) ||
            StatusPatient.includes("NOT FOUND"))
        ) {
          acum.notFound++;
        }

        if (audited) {
          acum.audited++;
        }

        acum.count++;
        return acum;
      },
      {
        active: 0,
        pending: 0,
        noMissingCode: 0,
        hasMissingCodes: 0,
        audited: 0,
        notFound: 0,
        count: 0,
      },
    );
}

export function formatBar(data = []) {
  const d = data.reduce(
    (acum, i) => {
      const StatusVerification = safeUpper(i?.StatusVerification);
      const StatusPatient = safeUpper(i?.StatusPatient);
      const carrierName = safeUpper(i?.spreedsheet?.CarrierName);
      const audited = i?.audited ?? false;

      if (audited) {
        acum.audited.push(i);
      }

      if (StatusVerification.includes("DONE BY")) {
        acum.completed.push(i);
      }

      if (StatusVerification === "EMPTY") {
        acum.notCompleted.push(i);
      }

      if (
        carrierName !== "EMPTY" &&
        carrierName !== "NO INSURANCE COMPANY" &&
        ((StatusVerification !== "EMPTY" &&
          !StatusVerification.includes("DONE BY")) ||
          StatusPatient.includes("NOT FOUND"))
      ) {
        acum.notFound.push(i);
      }

      return acum;
    },
    {
      completed: [],
      notCompleted: [],
      notFound: [],
      audited: [],
    },
  );

  return {
    completed: {
      data: formatLinearStatistics(d.completed),
      count: d.completed.length,
    },
    notCompleted: {
      data: formatLinearStatistics(d.notCompleted),
      count: d.notCompleted.length,
    },
    notFound: {
      data: formatLinearStatistics(d.notFound),
      count: d.notFound.length,
    },
    audited: {
      data: formatLinearStatistics(d.audited),
      count: d.audited.length,
    },
  };
}

export function formatDonut(formatedAsTableData = {}) {
  return {
    labels: [
      "Active",
      "Pending",
      "No Missing Fields",
      "Has Missing Fields",
      "Audited",
      "Not Found",
    ],
    series: [
      formatedAsTableData.active ?? 0,
      formatedAsTableData.pending ?? 0,
      formatedAsTableData.noMissingCode ?? 0,
      formatedAsTableData.hasMissingCodes ?? 0,
      formatedAsTableData.audited ?? 0,
      formatedAsTableData.notFound ?? 0,
    ],
  };
}
